
import { List, PullRefresh } from 'vant'
import { AuthLocationInfoType, PageResult } from '@/types/public'
import { GetNewNetworkpoints } from '@/apis/fault'
import { useRouter, useRoute } from 'vue-router'
import { parseNetworkPoint } from '@/utils/dataFactory'
import { UserLocationInfoStorage } from '@/storage/common'
import { NetworkpointItem, NetworkpointsQuery } from '@/types/fault'
import { defineComponent, ref, Ref, toRefs, watch, onUnmounted, SetupContext, onMounted } from 'vue'
import NameTag from './name-tag.vue'
import refreshPageSetup from '@/compositions/refreshPage'

export default defineComponent({
  name: 'Fault-Points',
  components: {
    VanList: List,
    VanPullRefresh: PullRefresh,
    NameTag,
  },
  props: {
    keywords: {
      type: String,
      required: true,
    },
    useNewApi: {
      type: Boolean,
      required: false,
    },
  },
  emits: ['clickItem'],
  setup(props, context) {
    const storageData = UserLocationInfoStorage.get<AuthLocationInfoType>()
    const router = useRouter()
    const route = useRoute()
    const is_only_own = useRoute().query.is_only_own as string | undefined
    const device_type = route.query.device_type as string
    const { keywords } = toRefs(props)
    let items: Ref<NetworkpointItem[]> = ref([])
    let {
      error,
      loading,
      finished,
      refreshing,
      _query,
      _ts,
      generateLoad,
      generateRefresh,
      errorDealFunc,
    } = refreshPageSetup()

    let timer: number
    const reGetItems = () => {
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        _ts = Date.now()
        items.value = []
        if (finished.value) {
          _query.page = 0
          finished.value = false
        } else {
          loading.value = true
          _query.page = 1
          getItems()
        }
      }, 500)
    }
    watch(keywords, (): void => {
      reGetItems()
    })

    const getItems = async (): Promise<void> => {
      if (!storageData?.lat || !storageData?.lng) {
        if (_query.page > 0) {
          _query.page--
        }
        return
      }
      const ts: number = _ts
      const { lng = 0, lat = 0 } = storageData
      const obj: NetworkpointsQuery = Object.assign({}, _query, {
        keywords: keywords.value as string,
        lng: Number(lng),
        lat: Number(lat),
        device_type: device_type || '',
      })
      console.log('is_only_own22', is_only_own)
      try {
        const result: PageResult = await GetNewNetworkpoints(obj)
        if (ts !== _ts) return
        if (refreshing.value) {
          items.value = []
          refreshing.value = false
        }
        let list = (result?.data as NetworkpointItem[]) || []
        list.forEach((it) => parseNetworkPoint(it))
        items.value = _query.page === 1 ? list : items.value.concat(...list)
        console.log('item.value', items.value)
        loading.value = false
        finished.value = list.length < _query.per_page
      } catch (err: unknown) {
        console.log('err', err)
        if (ts !== _ts) return
        errorDealFunc(err as { message: string })
      }
    }
    const onLoad = generateLoad(getItems)
    const onRefresh = generateRefresh(getItems)
    const onClickItem = (item: NetworkpointItem) => {
      context.emit('clickItem')
      const obj = {
        name: 'networkpoint-detail',
        params: {
          guid: item.guid,
        },
        query: {
          type: item.type,
        },
      }
      router.push(obj)
    }
    onUnmounted(() => {
      if (timer) clearTimeout(timer)
    })
    onMounted(() => {
      console.log('111', 111, props.useNewApi)
    })
    return {
      onClickItem,
      error,
      loading,
      finished,
      refreshing,
      _query,
      _ts,
      items,
      onLoad,
      onRefresh,
      getItems,
    }
  },
})
